export const DEFAULT_AUTO_ADVANCE = 0;

export const DEFAULT_PRESENT_UPCOMING = 10;

export const UPCOMING_VIDEO_TRANSITION = 1;

export const PLAYLIST_DEFAULTS_OPTIONS = {
  fluid: false,
  show: true,
  direction: 'vertical',
  total: 4,
  selector: false,
  renderTo: []
};
